import React, { useState } from 'react';
import { Card } from 'antd';
import { MailOutlined, CloseOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { CONTACT_EMAIL, APP_DESCRIPTION } from '../../constants/commonConstant';

const Notice = () => {
    const [visible, setVisible] = useState(true);

    if (!visible) return null;

    return (
        <div
            style={{
                width: '90%',
                maxWidth: '500px',
                padding: '10px',
                display: 'flex',
                paddingTop: '24px',
                paddingBottom: '24px',
                justifyContent: 'center',
                margin: '0 auto',
                position: 'relative',
            }}
        >
            <Card
                title={
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <InfoCircleOutlined style={{ fontSize: '20px', color: 'white' }} />
                        <span style={{ color: 'white' }}>News 🎉</span>
                    </div>
                }
                bordered={false}
                style={{
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    backgroundColor: '#363636',
                    color: 'white',
                    borderRadius: '12px',
                }}
                extra={
                    <CloseOutlined
                        style={{ fontSize: '16px', color: 'white', cursor: 'pointer' }}
                        onClick={() => setVisible(false)}
                    />
                }
            >
                <p style={{ fontSize: '14px', marginTop: '2px', marginBottom: '16px', lineHeight: '1.6', color: 'white' }}>
                    {APP_DESCRIPTION}
                </p>
                <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <MailOutlined style={{ color: 'white' }} />
                        <span style={{ color: 'white', fontSize: '14px' }}>{CONTACT_EMAIL}</span>
                    </div>
                </div>
            </Card>
        </div>
    );
};

export default Notice;
